import React from 'react';
import { __ } from '@wordpress/i18n';
import { isNil } from 'ramda';

// tools
import getDateTimeFromISOstring from '../../../../helpers/getDateTimeFromISOstring';
import getBandoLabel from '../../../../helpers/getBandoLabel';
import ChipWithIcon from '../../../../components/ChipWithIcon';

const CompanyInfo = ({ data }) => {
    return (
        !isNil(data)
            ? <div className="appPageSection__withBorder columns">
                <p className="appPageSection__pMeta">
                    <span>{__('Nome User', 'htr')}</span>
                    <span>{data.supplierName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Email', 'htr')}</span>
                    <span>{data.supplierEmail}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Data registrazione', 'htr')}</span>
                    <span>{getDateTimeFromISOstring(data.companyRegistrationDate)}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Assegnato il', 'htr')}</span>
                    <span>{data.assignedAt ? getDateTimeFromISOstring(data.assignedAt) : 'N/A'}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Assegnato a', 'htr')}</span>
                    <span>{data.assignedToUserName ? data.assignedToUserName : 'N/A'}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Stato account', 'htr')}</span>
                    <span>{getBandoLabel(data.companyStatus)}</span>
                </p>
                <div className="appPageSection__pMeta spanCol">
                    <span>{__('Categorie', 'htr')}</span>
                    <span className="flex">
                        {data.lookupData.map((o) => <ChipWithIcon key={`${o.id}`} value={o.value}/>)}
                    </span>
                </div>
            </div> : null
    )
}

export default CompanyInfo;